export default function ScoreBar({ score, dark = false }) {
  const pct = Math.round(((score - 70) / 30) * 100);
  return (
    <div className="flex items-center gap-3">
      <div className={`flex-1 h-px ${dark ? 'bg-sand/15' : 'bg-maroon/15'}`}>
        <div
          className={`h-full transition-all duration-1000 ease-spring ${dark ? 'bg-sand' : 'bg-wine'}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className={`text-[11px] font-medium tabular-nums tracking-wide ${dark ? 'text-sand/50' : 'text-maroon/50'}`}>
        {score} pts
      </span>
    </div>
  );
}
